<script setup lang="ts">
  defineProps<{
    label: string,
  }>()
</script>

<template>
  <div class="sidebar-group">
    <div class="sidebar-group-label">
      {{ label }}
    </div>
    <slot></slot>
  </div>
</template>
